import { Provider } from 'fuels';
import { HTLCPublicClient } from '@train-protocol/sdk';
import { getSolverLockDetails } from './public/getSolverLockDetails.js';
import { getTransaction } from './public/getTransaction.js';
import { getUserLockDetails } from './public/getUserLockDetails.js';
import { recoverSwap } from './public/recoverSwap.js';
export class FuelHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.provider = new Provider(config.rpcUrl);
    }
    async getUserLockDetails(params) {
        return getUserLockDetails(this.provider, params);
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetails(params, nodeUrl);
    }
    async recoverSwap(txHash, network) {
        return recoverSwap(this.provider, txHash, network);
    }
    async getTransaction(txHash) {
        return getTransaction(this.provider, txHash);
    }
}
